import API from "../utils/api";

export const ACTION_TYPES = {
    PROMOCODE_CREATE: 'PROMOCODE_CREATE',
    PROMOCODE_UPDATE: 'PROMOCODE_UPDATE',
    PROMOCODE_DELETE: 'PROMOCODE_DELETE',
    PROMOCODE_FETCH: 'PROMOCODE_FETCH',
    PROMOCODE_FETCH_ALL: 'PROMOCODE_FETCH_ALL',
    PROMOCODE_PAGINATION: 'PROMOCODE_PAGINATION'
}

export const fetchAll = () => dispatch => {
    API.promocode().fetchAll()
        .then(res => {
      
            dispatch({
                type: ACTION_TYPES.PROMOCODE_FETCH_ALL,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const Pagination = (page = 1, limit = 5, title = "") => dispatch => {
    API.promocode().fetchPagination(page, Math.abs(limit), title)
        .then(res =>{
         
            dispatch({
                type: ACTION_TYPES.PROMOCODE_PAGINATION,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const fetchById = (id, onSuccess) => dispatch => {
    API.promocode().fetchById(id)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.PROMOCODE_FETCH,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const create = (input, onSuccess) => dispatch => {
    API.promocode().create(input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.PROMOCODE_CREATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const update = (id, input, onSuccess) => dispatch => {
   
    API.promocode().update(id, input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.PROMOCODE_UPDATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const Delete = (id, onSuccess) => dispatch => {
    API.promocode().delete(id)
        .then(res =>{
         
            dispatch({
                type: ACTION_TYPES.PROMOCODE_DELETE,
                payload: res.data.id
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}